function AdminCtrl($scope, $auth, $state, $location, $stateParams, AppSettings, AdminService, toaster, $rootScope, CommonService) {
  'ngInject';
  // ViewModel
  const vm = this;
  vm.addUserForm = {};
  vm.responseReceived = false;
  vm.user = $auth.user;
  vm.users = [];
  vm.loading= false;
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.name = !$stateParams.name ? '' : $stateParams.name;
  vm.email = !$stateParams.email ? '' : $stateParams.email;
  vm.company = !$stateParams.company ? '' : $stateParams.company;
  vm.editFlag = false;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.userloading = false;
  vm.urlParams = {
    email: vm.email,
    pageNumber: vm.pageNumber,
    size: vm.size,
    name: vm.name,
    company: vm.company,
    sortBy: vm.sortBy
  };
  vm.init = function() {
    $rootScope.organizationNameView = false;
    vm.loading = true;
    AdminService.listUsers(vm.urlParams, function(response) {
      vm.loading = false;
      if(response.status = 200) {
        vm.usersResponse = response.data;
        vm.currentPage = !vm.usersResponse.pagination ? 1 : vm.usersResponse.pagination.current_page;
        vm.totalPages = !vm.usersResponse.pagination ? 1 : vm.usersResponse.pagination.total_pages;
        vm.users = response.data.users;
      }
   });
  };

  vm.search = function (name, email, company) {
    $state.go('user.admin.users', {name: name, email: email , company: company});
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.admin.users', {sortBy: param});
  };

  vm.paginate = function (param) {
    vm.url = vm.usersResponse.links[param];
    if(vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.admin.users', {pageNumber: vm.pageNumber, size: vm.size}, {inherit: false});
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.usersResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.admin.users', {pageNumber: vm.pageNumber, size: vm.size}, {inherit: false})
  };

  vm.saveUser = function () {
    vm.responseReceived = false;
    vm.submitted = true;
    vm.userloading = true;
    if(vm.addUserForm.organization){
      vm.addUserForm['organization_id'] = vm.addUserForm.organization.id;
    }
    if(vm.addUserForm.id){
      AdminService.updateUser(vm.addUserForm, function (response) {
        vm.userloading = false;
        if(response.status >= 200 && response.status < 300){
          vm.users[vm.users.map(function(a){return a.id }).indexOf(response.data.id)] = response.data;
          toaster.pop('info','User information updated.');
          vm.editFlag = false;
          vm.addUserForm = {};
          $scope.userForm.$setPristine();
          $scope.userForm.$setUntouched();
        }
        else{
          toaster.pop('error', CommonService.throwError(response));
        }
      });

    } else {
      AdminService.newUser(vm.addUserForm, function (response) {
        if (response.data.errors) {
          vm.userloading = false;
          toaster.pop('error', CommonService.throwError(response));
        }
        else{
          vm.userloading = false;
          toaster.pop('info', response.data.success[0]);
          vm.init();
        }
        vm.responseReceived = true;
        vm.addUserForm = {};
        $scope.userForm.$setPristine();
        $scope.userForm.$setUntouched();
      });
    }
  };

  vm.removeUser = function(user_id){
    for(var i = vm.users.length - 1; i >= 0; i--){
      if(vm.users[i].id == user_id){
        vm.init();
      }
    }
    toaster.pop('info', 'User deleted');
  };

  vm.deleteUser = function(user_id,user_role) {
    if($auth.user.role=="admin" || ($auth.user.role=='accountant' && user_role=='client')){
      swal({
        title: "Are you sure?",
        text: "Do you want to delete this user?",
        icon: "warning",
        dangerMode: true,
        buttons: [true, true]
    })
    .then(willDelete => {
      if (willDelete) {
        AdminService.deleteUser(user_id, function(data){
          if(data.status == 204)
          {
            vm.removeUser(user_id);
          }
       });
      }
    });
  }
};

  vm.editUser = function(user) {
    if($auth.user.role=="admin" || ($auth.user.role=='accountant' && user.role=='client')){
      vm.editFlag = true;
      $('html,body').animate({
          scrollTop: $("#user_form").offset().top - 100},
        'slow');
      vm.addUserForm = JSON.parse(JSON.stringify(user));
    }
  };

  vm.disable = function(user){
    if(($auth.user.role=='accountant' && (user.role=='admin' || user.role=='accountant'))){
      return 'edit-disabled';
    }
    return '';
  }

  vm.getUserStatusClass = function(invite,status){
      if(!invite || invite == ''){
        return "label label-default";
      } else if(invite && status == 'active'){
        return "label label-success";
      } else {
        return "label label-danger";
      }
  };

}


export default {
  name: 'AdminCtrl',
  fn: AdminCtrl
};
